import { FunctionComponent } from 'react';
import Layout from '@playground/SQL/components/Layout';
import PlaygroundProvider from '@playground/context';
import { Exercise } from '@playground/models/exercise.model';

interface Props {
  exercise: Exercise;
  mode: 'embed' | 'external';
}

const Playground: FunctionComponent<Props> = ({ exercise, mode = 'external' }) => {
  return (
    <PlaygroundProvider exercise={exercise} mode={mode}>
      <div className="h-full w-full overflow-hidden box-border flex flex-col">
        <Layout />
      </div>
    </PlaygroundProvider>
  );
};

export default Playground;
